import React, { useState } from "react"

import Logo from "../logo"

import "./_instructions-modal.scss"

import closeBtn from "../../assets/images/closeBtn.svg"

const InstructionsModal = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(false)

  const handleClose = () => {
    setIsModalOpen(true)
  }

  return (
    <div className="instructions-modal">
      <div
        className={`instructions-modal__container ${
          isModalOpen && "instructions-modal__container--close"
        }`}
      >
        <div className="instructions-modal__content">
          <button className="instructions-modal__btn" onClick={handleClose}>
            <img src={closeBtn} />
          </button>
          <div className="instructions-modal__row">
            <p>
              <h3>Welcome to Katika Music!</h3>
              To get started, simply select a country and start listening to a
              playlist curated by the Katika Team. This is a celebration of
              black music worldwide!
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InstructionsModal
